import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import FullWidthLayout from "../../layout/FullWidthLayout";
import CreateButton from "../../components/CreateButton";
import { CategoriesTable } from "../../components/tables/CategoriesTable";
import { Dimmer, Loader } from "semantic-ui-react";
import graphql from "babel-plugin-relay/macro";
import { createPaginationContainer } from "react-relay";

const CategoriesPage = (props) => {
  const {
    sidebarExpanded,
    setSidebarExpanded,
    setSidebarProps,
    menuExpanded,
    setMenuExpanded,
    allCategories,
    children,
    relay,
    ...rest
  } = props;
  const [search, setSearch] = useState();
  const { totalCount, edges } = allCategories.allCategories;
  const [isLoading, setIsLoading] = useState(false);
  const loadSearch = useRef(false);

  const categoriesParsed = edges.map((category, i) => {
    return {
      ...category.node,
    };
  });

  const t = useTranslation();
  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.categories")}`;
  }, [t]);

  const _loadMore = () => {
    if (!relay.hasMore() || relay.isLoading()) {
      return;
    }
    setIsLoading(true);
    relay.loadMore(20, () => {
      setIsLoading(false);
    });
  };

  const _refetch = () => {
    setIsLoading(true);

    relay.refetchConnection(
      search === "" || search === undefined ? 20 : null,
      () => setIsLoading(false),
      {
        name: search === "" || search === undefined ? null : search,
      }
    );
  };

  const handleScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      _loadMore();
    }
  };

  const onSearchText = useCallback(
    (txt) => {
      setSearch(txt);
    },
    [setSearch]
  );

  useEffect(() => {
    if (loadSearch.current) {
      setIsLoading(true);

      relay.refetchConnection(
        search === "" || search === undefined ? 20 : null,
        () => setIsLoading(false),
        {
          name: search === "" || search === undefined ? null : search,
        }
      );
    }
    loadSearch.current = true;
  }, [relay, search]);
  return (
    <FullWidthLayout>
      <Header
        title={t("title.categories")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
        onSearchTextChange={onSearchText}
      >
        <CreateButton
          allCategories={allCategories.allCategories}
          refetchData={_refetch}
        />
      </Header>
      <div className="table-wrapper">
        <>
          <CategoriesTable
            categoriesParsed={categoriesParsed}
            totalCount={totalCount}
            _refetch={_refetch}
            handleScroll={handleScroll}
            {...rest}
          />
          {isLoading && (
            <Dimmer inverted active>
              <Loader indeterminate />
            </Dimmer>
          )}
        </>
      </div>
    </FullWidthLayout>
  );
};

export default createPaginationContainer(
  CategoriesPage,
  {
    allCategories: graphql`
      fragment CategoriesPage_allCategories on Query
        @argumentDefinitions(
          name: { type: "String" }
          count: { type: "Int", defaultValue: 20 }
          cursor: { type: "String" }
        ) {
        allCategories(name: $name, first: $count, after: $cursor)
          @connection(key: "Categories_allCategories") {
          totalCount
          edges {
            node {
              id
              name
              picture
            }
          }
        }
      }
    `,
  },
  {
    direction: "forward",
    getConnectionFromProps(props) {
      return props.allCategories && props.allCategories.allCategories;
    },

    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
      };
    },
    query: graphql`
      query CategoriesPagePaginationQuery(
        $count: Int
        $cursor: String
        $name: String
      ) {
        ...CategoriesPage_allCategories
          @arguments(count: $count, cursor: $cursor, name: $name)
      }
    `,
  }
);
